import React, {FC} from "react";
import styles from "./heroBanner.module.css";
import CTAButton from "../../../common/v2/CTA-Button/cta-button";



interface Props {
    title: string;
    subTitle: string;
    subTitle2?: string;
    imageUrl: string;
    hideCta: boolean;
}

const HeroBanner: FC<Props> = (props)  => {
    return (

        <div className={styles.heroBanner}>
            <div className={styles.heroContent}>
                <h1 className={styles.title} style={{ color: "var(--theme-color-dark-purple)" }}>{props.title}</h1>
                <h2 className={styles.subTitle}>{props.subTitle}</h2>
                <p className={styles.subTitle2}>{props.subTitle2}</p>
                {!props.hideCta && (
                    <div className={styles.buttonWrapper}>
                        <CTAButton text="Nous Joindre" href="contact" />
                    </div>
                )}
            </div>
            <div className={styles.heroImageContainer}>
                <img src={props.imageUrl} alt="Description of the image"/>
            </div>
        </div>
    );
};

export default HeroBanner;